module.exports = function anonymous(it
) {
var out='<div class="definition-dragging" data-definition-id="'+(it.definition.id)+'">'+(it.definition.name)+'</div>';return out;
}